import { metrics } from '@atlassian/browser-metrics';

export const StaffDirectoryPageLoad = metrics.pageLoad({
  key: 'staff-directory',
});
